import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { UniqueStudentModel } from '../models/uniqueStudent.model';

@Injectable({
    providedIn: 'root'
})
export class UniqueRecoveryStudentsDataService {

    private readonly uniqueStudentNamesProperty = 'uniqueStudentNamesList';

    private SELECTION_API_URL = environment.UNIQUE_STUDENTS_DATA_SVC_URL;

    private uniqueDataItemsForSearch: UniqueStudentModel[];
    private uniqueDataItemsSubject: Subject<any[]>;
    uniqueDataItemsObservable: Observable<any[]>;

    private students: UniqueStudentModel[];

    constructor( private httpClient: HttpClient) {
        this.uniqueDataItemsSubject = new Subject<UniqueStudentModel[]>();
        this.uniqueDataItemsObservable = this.uniqueDataItemsSubject.asObservable();
        this.getSelectionData();
    }

    public sendGetUniqueStudentssRequest() {
        const url = this.SELECTION_API_URL;
        const response = this.httpClient.get(url);
        return response;
    }

    getSelectionData(): void {
        this.sendGetUniqueStudentssRequest().subscribe(
            (data: UniqueStudentModel[]) => {
                this.students = data[this.uniqueStudentNamesProperty];
                this.uniqueDataItemsForSearch = data;
                this.uniqueDataItemsSubject.next(this.uniqueDataItemsForSearch);
            }
        );
    }

    public getUniqueData() {
        return this.students;
    }
}